
































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {
  ManagementTemplatesItem,
  ManagementTemplatesItemImpl,
} from '@/store/mail_notify/management_templates/types';
import { SelectWings } from "wings-ui-components";
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {DetailFilterParams} from "@/store/call/statistic/types";
import { MsgTransports } from '@/store/types';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings}})
export default class MNManagementService extends Vue {
  @Ref('validator') validator: any;

  @Getter("managementServices") managementServicesList: any;

  @Action("getManagementTemplatesItem") actionGetItem: any;
  @Action("saveManagementTemplatesItem") actionSaveItem: any;
  @Action("deleteManagementTemplatesItem") actionDeleteItem: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getManagementServices") actionGetManagementServices: any;
  @Action("actionLog") actionLog: any;

  item = this.defaultItem();
  itemSaved = this.defaultItem();

  params = {transport: MsgTransports.MAILNOTIFY};
  managementServices = [];
  serviceProvidersList:  any = []
  private logObject: ActionLog = {};

  defaultItem(): ManagementTemplatesItem {
    return new ManagementTemplatesItemImpl();
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    this.actionGetManagementServices();

    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Mail Notify template",
          object_name: this.item.tmpl,
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        this.back();
      }
      this.serviceProvidersList = await this.actionGetServiceProviders({name: this.item.service_provider_name});
    }
  }

  back(): void {
    this.$router.push('/mail_notify/management_templates/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Mail Notify template",
            object_name: this.item.tmpl,
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSaveItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  onDeleteItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let isConfirm: boolean = await notifyDelete();
      if (isConfirm) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Removal",
            action_status: "success",
            object_type: "Mail Notify template",
            object_name: this.item.tmpl,
            addititional_info: getTranslatedParams({id: this.item.id})
          }
          await this.actionDeleteItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      }
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get status():number {
    return this.item.status_id;
  }

  set status(value:number) {
    this.item.status_id = (value ?? 0);
  }

  @Watch('item.service_provider_name', {immediate: false, deep: true})
  onServiceProviderChange(val: string) {
    if (val){
      this.managementServices = this.managementServicesList.filter((el:any) => el.service_provider_name === val);
    }else {
      this.item.mn_service_id = undefined;
    }
  }

};
